import { Grid } from "@pankod/refine-mui";
import SelettoreStruttura from "components/SelettoreStruttura";
import StatisticsDateFilter from "components/StatisticsDateFilter";
import moment from "moment";
import React, { useEffect, useState } from "react";
import axios from "utils/axios";

function HeaderFunnel({ setData, setLoading }) {
  const [start, setStart] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  ); // default inizio mese
  const [end, setEnd] = useState(moment(new Date()).format("YYYY-MM-DD"));
  //const [idStruttura, setIdStruttura] = useState(0);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      if (moment(end) <= moment(new Date()) && moment(start) <= moment(end)) {
        //fetch data
        /*const res = idStruttura
          ? await axios.get(
              `/api/stats?from=${start}&to=${end}&facility=${idStruttura}`
            )
          : await axios.get(`/api/stats?from=${start}&to=${end}`);*/
        const res = await axios.get(`/api/stats?from=${start}&to=${end}`);

        setData(res?.data);
        //console.log(res?.data);
        setLoading(false);
      }
    }
    fetchData();
  }, [start, end]); //idStruttura

  return (
    <Grid container gap={4}>
      <StatisticsDateFilter
        start={start}
        setStart={setStart}
        end={end}
        setEnd={setEnd}
      />
    </Grid>
  );
}

export default HeaderFunnel;
